import React, { useState } from "react";
import { Link } from "react-router-dom";
import Card from "components/Card";
import SearchBar from "components/SearchBar";
import { ReconciliationTableContainer, NavigatorContainer, Navigator } from "../style";
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const DailyReconciliationTable = ({ reports }) => {

  const [pageNumber, setPageNumber] = useState(1)
  const pageSize = 12
  const pageCount = Math.ceil(reports?.length/pageSize)

  const paginate = (array, page_size, page_number) => {
    const newArray = [...array]
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return newArray.slice((page_number - 1) * page_size, page_number * page_size);
  }

  const previousPage = () => {
    if(pageNumber > 1) {
      setPageNumber((pageNumber) => pageNumber-1)
    }
  }

  const nextPage = () => {
    if(pageNumber < pageCount) {
      setPageNumber((pageNumber) => pageNumber+1)
    }
  }

  const dailyReconciliationArray = reports.length ? paginate(reports, pageSize, pageNumber).map((report, index) => {
    return (
      <tr key={report.groupId}>
        <td className="booking-code">
        <Link to={`/booking-details/${report.groupId}`}>
          {report.bookingCode}
        </Link>
        </td>
        <td className="charge-date">{moment(report.chargeDateTime).tz(TIME_ZONE).format('MMM Do YYYY HH:mm A')}</td>
        <td className="customer-name">{report.customerName}</td>
        <td className="number-of-rooms">{report.numberOfRooms}</td>
        <td className="lodging">{report.lodging?.toFixed(2)}</td>
        <td className="misc">{report.misc?.toFixed(2)}</td>
        <td className="subtotal">{report.subTotal?.toFixed(2)}</td>
        <td className="MAT">{report.mat?.toFixed(2)}</td>
        <td className="HST">{report.hst?.toFixed(2)}</td>
        <td className="total-charged">{report.totalCharged?.toFixed(2)}</td>
        <td className="charge-type">{report.chargeType}</td>
        <td className="check-in">{moment(report.checkInDate).tz(TIME_ZONE).format('MMM Do YYYY')}</td>
        <td className="check-out">{moment(report.checkOutDate).tz(TIME_ZONE).format('MMM Do YYYY')}</td>
        <td className="booking-fee">{report.bookingFee?.toFixed(2)}</td>
      </tr>
    );
  }) : [
    <tr key={'no-data'}>
      <td colSpan="15">The requested data is unavailable for the selected reporting period, please try selecting a different timeframe.</td>
    </tr>
  ];

  return (
    <Card>
      <SearchBar />
      <ReconciliationTableContainer>
        <thead>
          <tr>
            <th className="booking-code">BOOKING CODE</th>
            <th className="charge-date">CHARGE DATE</th>
            <th className="customer-name">CUSTOMER NAME</th>
            <th className="number-of-rooms"># OF ROOMS</th>
            <th className="lodging">LODGING</th>
            <th className="misc">MISC</th>
            <th className="subtotal">SUBTOTAL</th>
            <th className="MAT">MAT</th>
            <th className="HST">HST</th>
            <th className="total-charged">TOTAL CHARGED</th>
            <th className="charge-type">CHARGE TYPE</th>
            <th className="check-in">CHECK IN</th>
            <th className="check-out">CHECK OUT</th>
            <th className="booking-fee">BOOKING FEE</th>
          </tr>
        </thead>
        <tbody>{dailyReconciliationArray}</tbody>
              {reports?.length > pageSize ? (
                <NavigatorContainer>
                  <Navigator
                    disabled={pageNumber <= 1}
                    onClick={previousPage}
                  >
                    {"<"} Back
                  </Navigator>
                  <Navigator
                    disabled={pageNumber >= reports.length / pageSize}
                    onClick={nextPage}
                  >
                    Next {">"}
                  </Navigator>
                </NavigatorContainer>
              ) : null}
      </ReconciliationTableContainer>
    </Card>
  );
};

export default DailyReconciliationTable;
